import { Environment } from '../env';
import { authorized, unauthorized } from './header';
import urls from './urls.json'
import axios from 'axios'


const AisleAdminEndpoints = new Set([
    urls.GET_PHONECODES,
    urls.GET_OTP_BY_PHONENUMBER
]);

// https://app.aisle.co/admin/events/all?app_name=Arike 

const fetchBaseUrl = (endpoint) => {
    const appName = localStorage.getItem('appName');
    let baseUrl
    if (appName === 'Aisle' || AisleAdminEndpoints.has(endpoint)) {
        baseUrl = Environment.is_development ? urls.TEST_BASE_URL : urls.PRODUCTION_BASE_URL
    } else {
        baseUrl = Environment.is_development ? urls.TEST_BASE_URL_ARIKE : urls.PRODUCTION_BASE_URL_ARIKE
    }
    console.log('base url', baseUrl)
    return baseUrl
}

const unauthorizedHttpPost = async (endpoint, params) => {
    const url = fetchBaseUrl() + endpoint
    try {
        const response = await axios.post(url, params, { headers: unauthorized() });
        if (response.status === 200) {
            return { status: true, data: response.data }
        }
    } catch (error) {
        try {
            if (error.response.status === 401) {
                localStorage.clear();
                window.location.href = '/login'
            } else {
                alert('Something went wrong')
                return { status: false, data: error.response.data }
            }
        } catch (error) {
            alert('Something went wrong')
            return { status: false, data: null }
        }
    }
}

const authorizedHttpPost = async (endpoint, params) => {
    const url = fetchBaseUrl(endpoint) + endpoint
    try {
        const response = await axios.post(url, params, { headers: authorized() });
        if (response.status === 200) {
            return { status: true, data: response.data }
        }
    } catch (error) {
        try {
            if (error.response.status === 401) {
                localStorage.clear();
                window.location.href = '/login'
            } else {
                if (error.response.data.is_backend_error) {
                    alert("500 - Internal Server Error")
                }
                return { status: false, data: error.response.data }
            }
        } catch (error) {
            alert('Something went wrong')
            return { status: false, data: null }
        }
    }
    return { status: false, data: null }
}

const authorizedHttpGet = async (endpoint, params) => {
    const url = fetchBaseUrl(endpoint) + endpoint
    try {
        const response = await axios.get(url, {
            params: params,
            headers: authorized(),
        });
        if (response.status >= 200 && response.status < 300) {
            return { status: true, data: response.data }
        }
    } catch (error) {
        try {
            if (error.response.status === 401) {
                localStorage.clear();
                window.location.reload();
            } else {
                if (error.response.data.is_backend_error) {
                    alert("🔴 500 - Internal Server Error")
                }
                return { status: false, data: error.response.data }
            }
        } catch (error) {
            alert('Something went wrong')
            return { status: false, data: null }
        }
    }
    return { status: false, data: null }
}

// Generic PUT helper for external URLs (e.g., S3 presigned URLs).
// Does not use fetchBaseUrl or auth headers by default.
const httpPut = async (url, body, headers = {}) => {
    try {
        const response = await axios.put(url, body, { headers });
        // For presigned URLs we mostly care about success/failure;
        // return a simple status flag.
        return { status: response.status >= 200 && response.status < 300 };
    } catch (error) {
        return { status: false, error };
    }
}

export { authorizedHttpPost, authorizedHttpGet, unauthorizedHttpPost, httpPut }
